import { Upload } from 'antd';
import type { ComponentProps } from 'react';
import styles from './upload-dragger.module.css';

type AntDraggerProps = ComponentProps<typeof Upload.Dragger>;

export type UploadDraggerProps = AntDraggerProps & {
  compact?: boolean;
  /** Solid filled (parchment) dropzone instead of the default dashed border. */
  filled?: boolean;
};

export const UploadDragger = ({ className, compact, filled, ...rest }: UploadDraggerProps) => {
  const classes = [
    styles.dragger,
    compact ? styles.compact : null,
    filled ? styles.filled : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <Upload.Dragger {...rest} className={classes} />;
};
